module.exports = __webpack_public_path__ + "img/ug512.e4c1a161.png";